// Single source of truth for the backend host. Set REACT_APP_API_BASE_URL
// at build time to point at a different environment; falls back to local
// dev so `npm start`/`npm run build` keep working with no extra setup.
export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://127.0.0.1:8000";
